"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _IconList["default"];
  }
});
var _IconList = _interopRequireDefault(require("./IconList"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }